import store from 'stores'
import scroll from 'core/scroll'

import CustomPageManager from './CustomPageManager'

class MainPageManager extends CustomPageManager {
  resetScroll () {
    if (document.scrollingElement) document.scrollingElement.scrollTop = 0
  }

  removePage () {
    this.resetScroll()
    super.removePage()
  }

  async initializePage (...args: Parameters<CustomPageManager['initializePage']>) {
    await super.initializePage(...args)
    store.loading.set(false)
  }

  extractPageInfo (page: Parameters<CustomPageManager['extractPageInfo']>[0]) {
    return super.extractPageInfo(page)
  }

  onRouteUpdate (...args: Parameters<CustomPageManager['onRouteUpdate']>) {
    const updated = super.onRouteUpdate(...args)
    if (updated !== true) return false
    store.loading.set(true)
    store.menu.set(null)
    scroll.unlock(true)
    return true
  }

  cancelTransition () {
    super.cancelTransition()
    store.loading.set(false)
  }

  triggerInternalRouting (...args: Parameters<CustomPageManager['triggerInternalRouting']>) {
    super.triggerInternalRouting(...args)
    store.loading.set(false)
  }

  async preparePage (...args: Parameters<CustomPageManager['preparePage']>) {
    await super.preparePage(...args)
    store.loading.set(false)
  }

  createPage (...args: Parameters<CustomPageManager['createPage']>) {
    return super.createPage(...args)
  }
}

export default MainPageManager
